module.exports = __webpack_public_path__ + "static/gallery6-d62304d6e0501831428f7cab99bdf760.jpg";